export const categories = [
  {
    id: 'cat-1',
    name: '科技数码',
    slug: 'tech-digital',
    description: '汇集前沿科技资讯、数码产品评测、互联网趋势分析，帮助您把握数字时代的脉搏，了解最新的技术创新与行业动态。',
    icon: 'ri-computer-line',
    articleCount: 18,
    color: 'accent',
  },
  {
    id: 'cat-2',
    name: '影视娱乐',
    slug: 'film-entertainment',
    description: '覆盖电影、电视剧、综艺节目、音乐、明星动态等泛娱乐内容，为您提供全面的影视资讯与深度娱乐解读。',
    icon: 'ri-film-line',
    articleCount: 22,
    color: 'primary',
  },
  {
    id: 'cat-3',
    name: '生活百科',
    slug: 'life-tips',
    description: '分享实用生活技巧、家居妙招、美食烹饪、旅行攻略等日常知识，让您的生活更加便捷、丰富、有趣。',
    icon: 'ri-lightbulb-line',
    articleCount: 15,
    color: 'secondary',
  },
  {
    id: 'cat-4',
    name: '教育学习',
    slug: 'education',
    description: '提供学习资源推荐、考试备考指南、职业技能提升、在线课程评测等教育相关内容，助力个人成长。',
    icon: 'ri-book-open-line',
    articleCount: 20,
    color: 'accent',
  },
  {
    id: 'cat-5',
    name: '健康养生',
    slug: 'health-wellness',
    description: '关注健康饮食、运动健身、心理健康、中医养生等领域，为您的健康生活提供科学指导与实用建议。',
    icon: 'ri-heart-pulse-line',
    articleCount: 16,
    color: 'primary',
  },
];

export const categoryMap: Record<string, typeof categories[0]> = {};
categories.forEach((cat) => {
  categoryMap[cat.slug] = cat;
});